<!-- Main content area -->
<div *ngIf="!showNoDataMessage">
   <!-- Bar Chart Component -->
   <div class="bar-chart">
     <app-bar-chart
       [ticker]="ticker"
       (noDataEvent)="onBarChartDataStatus(!$event)">
     </app-bar-chart>
   </div>

   <!-- Table Component -->
   <div class="table-responsive">
     <app-table
       [dividentPerShareArray]="dividentPerShareArray"
       [ebitPerShareArray]="ebitPerShareArray"
       [epsArray]="epsArray"
       [revenuePerShare]="revenuePerShare"
       [epsFwd]="epsFwd"
       [price_to_earning]="price_to_earning"
       (noDataEvent)="onTableDataStatus(!$event)">
     </app-table>
   </div>
 </div>

 <!-- No Data Message (only shown when both components report no data) -->
 <div *ngIf="showNoDataMessage" class="no-data-container">
   <img src="assets/images/financials/no-data-image.svg" alt="No data" />
   <p>No Data Available!</p>
 </div>
